<template>
  <v-card>
    <v-card-title>
      <div
        style="text-align: center; width: 100%;"
        class="text-xs-center headline primary--text"
      >
        {{
          textoTela()
          }}
      </div>
      <div
        style="text-align: center; width: 100%;"
        class="text-xs-center subtitle grey--text text--darken-2 font-weight-bold mb-3"
      >{{posto.nome_fantasia}}</div>
    </v-card-title>
    <v-bottom-nav
      :active.sync="teste"
      color="primary"
      :value="true"
      dark
      shift
    >
      <v-btn dark @click="step = 1">
        <span>Posto</span>
        <v-icon>local_gas_station</v-icon>
      </v-btn>

      <v-btn dark @click="step = 2">
        <span>Representante</span>
        <v-icon>account_circle</v-icon>
      </v-btn>

      <v-btn dark @click="step = 3">
        <span>Contrato</span>
        <v-icon>description</v-icon>
      </v-btn>

      <v-btn dark @click="step = 4">
        <span>Automação</span>
        <v-icon>android</v-icon>
      </v-btn>

    </v-bottom-nav>
    <v-card-text>
      <v-container fluid grid-list-md>
        <v-stepper v-model="step" style="box-shadow: none;">
          <v-stepper-items>
            <v-stepper-content step='1' class="pa-0">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    mask="##.###.###/####-##"
                    readonly
                    label="CNPJ do Posto"
                    v-model="posto.cnpj"
                    outline
                    disabled
                    hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field label="Razão Social" v-model="posto.razao_social" outline hide-details></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field label="Nome Fantasia" v-model="posto.nome_fantasia" outline hide-details></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field label="E-mail de notificações" v-model="posto.email" outline hide-details></v-text-field>
                </v-flex>
                <v-flex xs12 align-self-center class="mt-3">
                  <v-tooltip bottom>
                    <v-btn
                      slot="activator"
                      round
                      outline
                      block
                      @click="posto.ativo = !posto.ativo"
                      :color="posto.ativo ? 'green darken-2': 'red darken-2'"
                    >
                      <template v-if="posto.ativo">ATIVO</template>
                      <template v-else>INATIVO</template>
                    </v-btn>
                    <template v-if="posto.ativo">Clique para desativar</template>
                    <template v-else>Clique para ativar</template>
                  </v-tooltip>
                  <v-btn
                    round
                    outline
                    block
                    @click="posto.is_white_label = !posto.is_white_label"
                    :color="posto.is_white_label ? 'red darken-2' : 'green darken-2'"
                  >
                    {{
                      posto.is_white_label ?
                      'Desativar White Label'
                      :
                      'Ativar White Label'
                    }}
                  </v-btn>
                  <v-btn
                    :disabled="!posto.is_white_label && !posto.rede_sindicato"
                    round
                    outline
                    block
                    @click="posto.is_simultaneo = !posto.is_simultaneo"
                    :color="posto.is_simultaneo ? 'red darken-2' : 'green darken-2'"
                  >
                    {{
                      posto.is_simultaneo ?
                      'Desativar uso simultâneo'
                      :
                      'Ativar uso simultâneo'
                    }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-stepper-content>
            <v-stepper-content step='2' class="pa-0">
              <v-layout row wrap v-if="representante && !transferir">
                <v-flex xs6>
                  <v-text-field
                    label="Nome do Representante"
                    v-model="representante.nome"
                    outline
                    hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    label="Nome do Representante"
                    v-model="representante.sobrenome"
                    outline
                    hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    mask="###.###.###-##"
                    label="CPF do Representante"
                    v-model="representante.cpf"
                    outline
                    hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Email do Representante"
                    v-model="representante.email"
                    outline
                    hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    mask="(##) # ####-####"
                    label="Telefone do Representante"
                    v-model="representante.telefone"
                    outline
                    hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 v-if="verificacaoTelefone.cadastrado || (verificacaoTelefone.pessoa && representante && verificacaoTelefone.pessoa.id_pessoa !=  representante.id_pessoa)">
                  <v-card class="ma-2" elevation="4">
                    <v-card-title class="justify-center">
                      <h4
                        v-if="verificacaoTelefone.cadastrado || verificacaoTelefone.pessoa"
                        class="text-xs-center error--text"
                      >
                        Esse telefone já foi cadastrado
                      </h4>
                    </v-card-title>
                    <v-card-text>
                      <v-flex
                        class="error--text"
                        v-if="verificacaoTelefone.quantidade > 0"
                      >
                        {{ verificacaoTelefone.quantidade }} {{ verificacaoTelefone.quantidade === 1 ? 'pessoa cadastrou esse telefone' : 'pessoas cadastraram esse telefone' }}
                      </v-flex>
                      <v-flex
                        class="error--text"
                        v-if="verificacaoTelefone.ids_cadastrados.length > 0"
                      >
                        IDs que registraram esse telefone: <span v-for="(fone, index) in verificacaoTelefone.ids_cadastrados" :key="index">
                          {{ fone }}<span v-if="index < verificacaoTelefone.ids_cadastrados.length - 1 ">,</span>
                        </span>
                      </v-flex>
                      <v-layout wrap justify-space-between v-if="verificacaoTelefone.pessoa" class="error--text">
                        <v-flex xs12><h4 class="text-xs-center">Cadastro Firebase</h4></v-flex>
                        <v-flex xs11>Nome: {{ verificacaoTelefone.pessoa.nome_completo }}</v-flex>
                        <v-flex xs5>CPF: {{ verificacaoTelefone.pessoa.cpf }}</v-flex>
                        <v-flex xs5>ID: {{ verificacaoTelefone.pessoa.id_pessoa }}</v-flex>
                        <v-flex xs11>E-mail: {{ verificacaoTelefone.pessoa.email }}</v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12>
                  <v-btn
                    block
                    round
                    small
                    color="primary"
                    @click="transferir = !transferir"
                  >
                      <v-icon
                        style="margin-right: 3px;"
                      >{{transferir ? 'close' : 'sync_alt'}}</v-icon>
                      {{transferir ? '' : 'Transferir Posto'}}
                  </v-btn>
                  <v-btn block round small color="secondary" @click="cardSmartlock = !cardSmartlock">
                      <v-icon style="margin-right: 3px;">{{cardSmartlock ? 'close' : 'password'}}</v-icon>
                      {{cardSmartlock ? '' : 'Smartlock'}}
                  </v-btn>
                  <v-card elevation="5" v-show="cardSmartlock" class="ml-4 mr-4 mt-2 mb-3">
                      <v-card-title style="font-size: 1.3em;">Cadastrar Smartlock</v-card-title>
                      <v-card-text>
                          <v-text-field
                              label="Digite o novo smartlock"
                              v-model="smartlock"
                              placeholder="******"
                              :type="show ? 'text' : 'password'"
                              :append-icon="show ? 'visibility' : 'visibility_off'"
                              @click:append="show = !show"
                              :min="4"
                              autocomplete="off"
                              single-line
                          ></v-text-field>
                      </v-card-text>
                      <v-card-actions>
                          <v-btn
                            color="secondary"
                            block
                            @click="cadastrarSmartlock"
                            :disabled="!smartlock || smartlock < 4"
                            :loading="loading"
                          >
                              <v-icon class="mr-1">save</v-icon>
                              Salvar
                          </v-btn>
                      </v-card-actions>
                  </v-card>
                </v-flex>
              </v-layout>
              <v-layout wrap justify-center v-else>
                <v-flex xs8 class="primary--text" v-if="!representante">
                  <h3>Esse posto pertence a Automação</h3>
                </v-flex>
                <v-flex xs12>
                  <v-card class="ma-4">
                    <v-card-title class="justify-center" style="font-size: 1.3em;">
                      Transferir para representante
                    </v-card-title>
                    <v-card-text>
                      <v-text-field
                        class="mb-3"
                        mask="###.###.###-##"
                        label="CPF do Representante"
                        v-model="representante_data.cpf"
                        outline
                        hide-details
                      ></v-text-field>
                      <v-text-field
                        class="mb-3"
                        label="Email do Representante"
                        v-model="representante_data.email"
                        outline
                        hide-details
                      ></v-text-field>
                      <v-text-field
                        label="Nome do Representante"
                        v-model="representante_data.nome"
                        outline
                        hide-details
                      ></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn
                        block
                        @click="transferir = !transferir"
                        v-if="
                          representante
                        "
                      >
                        <v-icon>close</v-icon>
                      </v-btn>
                      <v-btn
                        color="primary"
                        block
                        :disabled="
                          !representante_data.cpf ||
                          !representante_data.email ||
                          !representante_data.nome
                        "
                        @click="transferirPosto"
                        :loading="loading"
                      >
                        <v-icon>sync_alt</v-icon>
                      </v-btn>
                    </v-card-actions>
                </v-card>
                </v-flex>
              </v-layout>
            </v-stepper-content>
            <v-stepper-content step='3' class="pa-0">
              <v-flex>
                <h2 style="text-align: center;">Dados da Fatura</h2>
              </v-flex>
              <v-flex xs12 class="pb-0">
                <v-menu
                  transition="scale-transition"
                  offset-y
                  full-width
                  lazy
                  max-width="290px"
                  min-width="290px"
                  :close-on-content-click="false"
                  v-model="data_faturamento"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="data_fatura_formated"
                      outline
                      v-on="on"
                      label="Data do proximo faturamento"
                      required
                      :rules="[
                            v => !!v || 'O campo é obrigatório'
                          ]"
                      readonly
                    ></v-text-field>
                  </template>
                    <v-date-picker
                      v-model="data_fatura"
                      no-title
                      locale="pt-br"
                      :allowed-dates="(date) => {
                        return Date.parse(date) > today
                      }"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        flat
                        color="green darken-1"
                        class="caption font-weight-medium"
                        @click="data_faturamento = false"
                      >FECHAR</v-btn>
                    </v-date-picker>
                </v-menu>
                <h5 v-if="data_fatura_formated">
                  Em {{data_fatura_formated}} será gerado uma fatura cobrando o posto {{posto.nome_fantasia}}.
                </h5>
              </v-flex>
              <v-flex xs12 class="mb-3">
                <v-switch
                  v-model="gerar_boleto"
                  label="Gerar boleto Efi"
                  color="primary"
                ></v-switch>
                <h5>
                  {{
                    gerar_boleto ?
                    'Será gerado um boleto e será enviado para o e-mail do posto.'
                    :
                    'Não será gerado boleto. Você precisar gerar o boleto de acordo com as informações da fatura.'
                  }}
                </h5>
              </v-flex>
              <v-flex xs12 class="mb-3">
                <v-switch
                  v-model="posto.baixa_automatica"
                  label="Dar baixar automaticamente"
                  color="primary"
                ></v-switch>
                <h5>
                  {{
                    posto.baixa_automatica ?
                    'Será dado baixar automaticamente nas compras pós pagas que foram realizadas a 5 dias ou mais..'
                    :
                    'Não será dado baixar automaticamente nas compras pós pagas.'
                  }}
                </h5>
              </v-flex>
              <v-divider></v-divider>
              <v-layout row wrap>
                <v-flex>
                  <h2 style="text-align: center;">Taxas de Faturamento</h2>
                </v-flex>
                <v-flex xs12>
                  <v-switch
                    v-model="tem_taxa_empresa"
                    label="Tem taxa de abastecimento por empresa"
                    color="primary"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 v-if="tem_taxa_empresa">
                  <v-text-field
                    v-model="taxa_empresa"
                    v-if="rendering"
                    outline
                    label="Taxa de abastecimento por empresa"
                    hide-details
                    type="number"
                    suffix="%"
                  ></v-text-field>
                  <h5>Em cada abastecimento {{taxa_empresa}}% pertence a Apetrus.</h5>
                </v-flex>
                <v-flex xs12>
                  <v-switch
                    v-model="tem_valor_mensal_fatura"
                    label="Tem mensalidade"
                    color="primary"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 v-if="tem_valor_mensal_fatura">
                  <v-text-field
                    v-model.lazy="valor_mensal_fatura"
                    v-if="rendering"
                    outline
                    label="Mensalidade"
                    v-money="money"
                    hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-switch
                    v-model="tem_taxa_por_abastecimento"
                    label="Tem taxa por abastecimento"
                    color="primary"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 v-if="tem_taxa_por_abastecimento">
                  <v-text-field
                    v-model="taxa_por_abastecimento"
                    v-if="rendering"
                    outline
                    label="Taxa por abastecimento"
                    hide-details
                    type="number"
                    suffix="%"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-switch
                    v-model="tem_taxa_por_combustivel"
                    label="Tem taxa por combustível"
                    color="primary"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 v-if="tem_taxa_por_combustivel">
                  <v-text-field
                    v-model.lazy="taxa_por_combustivel"
                    v-if="rendering"
                    outline
                    label="Taxa por combustível"
                    hide-details
                    v-money="money"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-switch
                    v-model="tem_taxa_proposta_apetrus"
                    label="Tem taxa para Proposta Apetrus"
                    color="primary"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 v-if="tem_taxa_proposta_apetrus">
                  <v-text-field
                    v-model="taxa_proposta_apetrus"
                    v-if="rendering"
                    outline
                    label="Taxa para Proposta Apetrus"
                    hide-details
                    type="number"
                    suffix="%"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 class="mt-4">
                  <v-spacer></v-spacer>
                  <v-divider></v-divider>
                  <h2 style="text-align: center;" class="mt-4">Taxas da Carteira Digital</h2>
                </v-flex>
                <v-flex xs12>
                  <v-switch
                    v-model="tem_taxa_carteira_clientes"
                    label="Tem taxa de recebimento por clientes"
                    color="primary"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 v-if="tem_taxa_carteira_clientes">
                  <v-text-field
                    v-model="taxa_carteira_clientes"
                    v-if="rendering"
                    outline
                    label="Taxa de recebimento por clientes"
                    hide-details
                    type="number"
                    suffix="%"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-switch
                    v-model="tem_taxa_carteira_empresa"
                    label="Tem taxa de recebimento por empresa"
                    color="primary"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 v-if="tem_taxa_carteira_empresa">
                  <v-text-field
                    v-model="taxa_carteira_empresa"
                    v-if="rendering"
                    outline
                    label="Taxa de recebimento por empresa"
                    hide-details
                    type="number"
                    suffix="%"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 class="mt-4">
                  <v-spacer></v-spacer>
                  <v-divider></v-divider>
                  <h2 style="text-align: center;" class="mt-4">Programas</h2>
                </v-flex>
                <v-flex xs12 v-if="posto.programa_incentivo">
                  <v-switch
                    v-model="posto.programa_incentivo.ativo_apetrus"
                    label="Programa de incentivo do frentista"
                    color="primary"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 v-if="posto.programa_incentivo && posto.programa_incentivo.ativo_apetrus">
                  <v-text-field
                    v-model="percentual_incentivo"
                    v-if="rendering"
                    outline
                    label="Percentual incentivo do frentista"
                    hide-details
                    type="number"
                    suffix="%"
                  ></v-text-field>
                  <h5>Em uma compra com valor de 10 reias, será dado R$ {{valor_incentivo}}</h5>
                </v-flex>
                <v-flex xs12 v-if="posto.programa_doacao">
                  <v-switch
                    v-model="posto.programa_doacao.ativo_apetrus"
                    label="Programa de doação"
                    color="primary"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 v-if="posto.programa_doacao && posto.programa_doacao.ativo_apetrus">
                  <v-text-field
                    v-model.lazy="valor_doacao"
                    v-if="rendering"
                    outline
                    label="Valor Doacão"
                    hide-details
                    v-money="money"
                  ></v-text-field>
                  <h5>Em cada compra será doado {{valor_doacao}} para instituição</h5>
                </v-flex>
                <v-flex xs12>
                  <v-switch
                    v-model="posto.tem_programa_assinatura"
                    label="Programa de Assinatura"
                    color="primary"
                  ></v-switch>
                </v-flex>
              </v-layout>
            </v-stepper-content>
            <v-stepper-content step='4' class="pa-0">
              <v-layout row wrap>
                <v-flex>
                  <h3 style="text-align: center;" class="mb-2">Selecione uma Empresa de Automação</h3>
                  <v-select
                    :items="empresas_automacao"
                    item-text="nome_fantasia"
                    item-value="cnpj"
                    solo
                    clearable
                    placeholder="Clique para selecionar uma Automação"
                    :loading="loading"
                    @change="selecionarAutomacao()"
                    outline
                    single-line
                    v-model="cnpj_empresa"
                  />
                </v-flex>
              </v-layout>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-btn flat color="grey darken-2" @click="fechar()">Voltar</v-btn>
      <v-spacer></v-spacer>
      <v-btn flat color="green" @click="editar()" :loading="loading" :disabled="step==4 || (step==2 && !representante)">Salvar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { VMoney } from 'v-money'

export default {
  props: ['cnpj'],
  data () {
    let todayDate = new Date().toISOString().substr(0, 10)
    return {
      posto: {
        programa_incentivo: {},
        programa_doacao: {},
        baixa_automatica: false,
        is_white_label: false
      },
      today: Date.parse(todayDate),
      teste: 0,
      verificacaoTelefone: {
        cadastrado: false,
        quantidade: 0,
        ids_cadastrados: [],
        pessoa: undefined
      },
      transferir: false,
      cnpj_empresa: undefined,
      data_faturamento: false,
      valor_doacao: 'R$ 0,00',
      percentual_incentivo: 0,
      representante: {},
      representante_data: {
        cpf: '',
        email: '',
        nome: ''
      },
      step: 1,
      cardSmartlock: false,
      show: false,
      smartlock: '',
      valor_mensal_fatura: null,
      tem_valor_mensal_fatura: false,
      taxa_empresa: null,
      tem_taxa_empresa: false,
      tem_taxa_por_abastecimento: false,
      tem_taxa_carteira_clientes: false,
      tem_taxa_carteira_empresa: false,
      tem_taxa_proposta_apetrus: false,
      tem_taxa_por_combustivel: false,
      taxa_carteira_clientes: undefined,
      taxa_carteira_empresa: undefined,
      taxa_proposta_apetrus: undefined,
      taxa_por_abastecimento: null,
      taxa_por_combustivel: null,
      valor_incentivo: '0,00 centavos',
      data_fatura: null,
      data_fatura_formated: null,
      gerar_boleto: false,
      rendering: true,
      empresas_automacao: [],
      money: {
        decimal: '.',
        thousands: '',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      }
    }
  },
  computed: {
    loading () {
      return this.$store.getters.loading
    }
  },
  watch: {
    taxa_por_abastecimento (val) {
      this.posto.taxa_por_abastecimento = val
    },
    tem_taxa_proposta_apetrus (val) {
      if (!val) this.tem_taxa_proposta_apetrus = undefined
    },
    valor_doacao (val) {
      if (val) {
        this.posto.programa_doacao.valor_doacao = Number(val.replace('R$ ', ''))
      }
    },
    tem_taxa_empresa (val) {
      if (!val) {
        this.taxa_empresa = null
        this.posto.taxa_empresa = null
      }
    },
    tem_valor_mensal_fatura (val) {
      if (!val) {
        this.valor_mensal_fatura = null
        this.posto.valor_fatura_mensal = null
      }
    },
    valor_mensal_fatura (val) {
      this.posto.valor_fatura_mensal = val
    },
    tem_taxa_por_combustivel (val) {
      if (!val) {
        this.taxa_por_combustivel = null
        this.posto.taxa_por_combustivel = null
      }
    },
    taxa_por_combustivel (val) {
      this.posto.taxa_por_combustivel = val
    },
    tem_taxa_por_abastecimento (val) {
      if (!val) {
        this.taxa_por_abastecimento = null
        this.posto.taxa_por_abastecimento = null
      }
    },
    taxa_empresa (val) {
      this.posto.taxa_empresa = val
    },
    tem_taxa_carteira_clientes (val) {
      if (!val) this.taxa_carteira_clientes = undefined
    },
    tem_taxa_carteira_empresa (val) {
      if (!val) this.taxa_carteira_empresa = undefined
    },
    percentual_incentivo (val) {
      val = Number(val)
      if (val) {
        let valorCompra = 10
        let valorIncentivo = (valorCompra * val) / 100
        this.posto.programa_incentivo.percentual = val
        this.valor_incentivo = `${valorIncentivo.toFixed(2)} ${valorIncentivo >= 1 ? 'reais' : 'centavos'}`
      }
    },
    cnpj (val) {
      if (val) {
        this.carregarPosto()
      } else {
        this.posto = {}
      }
    },
    data_fatura (val) {
      this.data_faturamento = false
      if (val) {
        this.data_fatura_formated = val
          .split('-')
          .reverse()
          .join('/')
      } else {
        this.data_fatura_formated = null
      }
    },
    step (val) {
      if (val === 4) this.pegarEmpresaAutomacao()
    },
    'representante.telefone' (val) {
     if (val && val.length === 11) {
      this.verificarTelefone()
     } else {
      this.verificacaoTelefone.pessoa = undefined
      this.verificacaoTelefone.ids_cadastrados = []
      this.verificacaoTelefone.cadastrado = false
      this.verificacaoTelefone.quantidade = 0
     }
    }
  },
  mounted () {
    if (this.cnpj) {
      this.carregarPosto()
    }
  },
  methods: {
    textoTela () {
      switch (this.step) {
        case 1:
          return 'Editando Dados do Posto'
        case 2:
          return 'Editando Dados do Representante'
        case 3:
        return 'Editando do Contrato do Posto'
      }
    },
    carregarPosto () {
      this.$store.dispatch('detalhesPosto', this.cnpj).then(json => {
        this.posto = json
        this.cnpj_empresa = json.empresa_automacao
        this.representante = json.representante
        this.valor_mensal_fatura = json.valor_fatura_mensal
        this.taxa_por_abastecimento = json.taxa_por_abastecimento
        this.taxa_empresa = json.taxa_empresa
        this.tem_taxa_empresa = this.taxa_empresa !== null
        this.tem_taxa_por_abastecimento = this.taxa_por_abastecimento !== null
        this.tem_valor_mensal_fatura = this.valor_mensal_fatura !== null
        this.taxa_carteira_clientes = json.taxa_recebimento_cliente ? json.taxa_recebimento_cliente : undefined
        this.taxa_carteira_empresa = json.taxa_recebimento_empresa ? json.taxa_recebimento_empresa : undefined
        this.taxa_proposta_apetrus = json.taxa_proposta_apetrus ? json.taxa_proposta_apetrus : undefined
        this.taxa_por_combustivel = json.taxa_por_combustivel
        this.tem_taxa_por_combustivel = json.taxa_por_combustivel !== null
        this.tem_taxa_proposta_apetrus = !!this.taxa_proposta_apetrus
        this.tem_taxa_carteira_clientes = !!this.taxa_carteira_clientes
        this.tem_taxa_carteira_empresa = !!this.taxa_carteira_empresa
        if (json.data_ultimo_faturamento_apetrus) {
          this.data_fatura = json.data_ultimo_faturamento_apetrus
          this.data_fatura_formated = json.data_ultimo_faturamento_apetrus
          .split('-')
          .reverse()
          .join('/')
        }
        this.gerar_boleto = json.gerar_boleto
        this.rendering = false
        if (this.posto.programa_incentivo === null) {
          this.posto.programa_incentivo = {
            percentual: 1,
            ativo_apetrus: false
          }
        } else {
          this.percentual_incentivo = this.posto.programa_incentivo.percentual
        }
        if (this.posto.programa_doacao === null) {
          this.posto.programa_doacao = {
            valor_doacao: '0,00',
            ativo_apetrus: false
          }
        } else {
          this.valor_doacao = this.posto.programa_doacao.valor_doacao
        }
        this.$nextTick(() => {
          this.rendering = true
        })
      })
    },
    atualizarPosto () {
      if (this.posto.valor_fatura_mensal !== null) {
        this.posto.valor_fatura_mensal = parseFloat(
          this.valor_mensal_fatura.split(' ')[1]
        )
      }
      if (this.posto.taxa_por_combustivel !== null) {
        this.posto.taxa_por_combustivel = parseFloat(
          this.taxa_por_combustivel.split(' ')[1]
        )
      }
      this.posto.taxa_recebimento_cliente = this.tem_taxa_carteira_clientes ? Number(this.taxa_carteira_clientes) : null
      this.posto.taxa_recebimento_empresa = this.tem_taxa_carteira_empresa ? Number(this.taxa_carteira_empresa) : null
      this.posto.taxa_proposta_apetrus = this.tem_taxa_proposta_apetrus ? Number(this.taxa_proposta_apetrus) : null
      this.posto.gerar_boleto = this.gerar_boleto
      this.posto.data_ultimo_faturamento_apetrus = this.data_fatura
      this.$store.dispatch('atualizarPosto', this.posto).then(() => {
        this.$emit('success')
        this.$emit('carregar')
      })
    },
    mudanca_tela () {
      if (this.step === 1) {
        this.step = 2
      } else {
        this.step = 1
      }
    },
    async editarRepresentante () {
      await this.$store.dispatch('signUserUp', {
        email: this.representante.email,
        password: this.representante.cpf,
        logar: false
      })

      this.$store.dispatch('trocarOuEditarRepresentate', { ...this.representante, cnpj: this.posto.cnpj }).then(() => {
        this.$emit('editado', 'Representante editado com sucesso')
        this.$emit('success')
      }).catch(() => {
        this.$emit('error', 'Não foi possível editar Representante')
      })
    },
    editar () {
      if (this.step === 1 || this.step === 3) {
        this.atualizarPosto()
      } else {
        this.editarRepresentante()
      }
    },
    fechar () {
      this.valor_doacao = '0,00'
      this.percentual_incentivo = 0
      this.valor_incentivo = '0,00 centavos'
      this.step = 1
      this.teste = 0
      this.$emit('close')
    },
    cadastrarSmartlock () {
        this.$store.dispatch('cadSmartLockPessoa', {
            smartlock: this.smartlock,
            id_pessoa: this.posto.representante.id_pessoa
        }).then(() => {
            this.cardSmartlock = false
            this.smartlock = ''
            this.$emit('editado', 'Smartlock cadastrado com sucesso')
        }).catch(() => {
            this.$emit('error', 'Não foi possível cadastrar Smartlock')
        })
    },
    pegarEmpresaAutomacao () {
      this.$store.dispatch('procurarEmpresasPorAdm', {
        filtros: { tipo_empresa: 3 }
      }).then(json => {
        this.empresas_automacao = json
      })
    },
    selecionarAutomacao () {
      this.$store.dispatch('automacaoEmpresa', {
        cnpj_posto: this.cnpj,
        cnpj_empresa: this.cnpj_empresa ? this.cnpj_empresa : null
      }).then(() => {
        this.carregarPosto()
      })
    },
    verificarTelefone () {
      this.$store.dispatch('verificarTelefone', {
        id_pessoa: this.representante.id_pessoa,
        telefone: this.representante.telefone.slice(3, 11)
      }).then(json => {
        this.verificacaoTelefone = json
      })
    },
    transferirPosto () {
      this.$store.dispatch('transferirPosto', {
        cpf: this.representante_data.cpf,
        nome: this.representante_data.nome,
        email: this.representante_data.email,
        cnpj: this.cnpj
      }).then(() => {
        this.carregarPosto()
        this.$emit('carregar')
        this.$emit('editado', 'Representante editado com sucesso.')
        this.transferir = false
        this.representante_data.cpf = ''
        this.representante_data.nome = ''
        this.representante_data.email = ''
      })
    }
  },
  directives: { money: VMoney }
}
</script>
